import { provideNgxStripe } from 'ngx-stripe';

export const stripeBootstrapProviders = [
    provideNgxStripe()
]